import React from "react";

function SvgIcMapPoi105(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24.04 24v2h-16v-2h16zM17 4v5.183c1.162.414 2 1.512 2 2.817 0 .95-.45 1.784-1.137 2.334.23.318.481.622.732.922C19.285 16.078 20 16.93 20 18c0 2.206-1.795 4-4 4-2.206 0-4-1.794-4-4a1 1 0 112 0c0 1.103.897 2 2 2s2-.897 2-2c0-.342-.476-.909-.937-1.457-.369-.439-.792-.954-1.16-1.552A2.994 2.994 0 0113 12a2.99 2.99 0 012-2.817V4h2z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi105;
